<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
          <v-flex lg3 md3 sm12>
            <v-expansion-panels v-model="panel" accordion>
              <v-expansion-panel expand v-model="panel">
                <v-expansion-panel-header>
                  Thông tin cơ bản
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list>
                    <v-list-item-group v-model="selectedMenuItem" color="primary" mandatory>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Chung</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Tồn kho</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Hình ảnh</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Tuỳ chọn</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Đơn xuất</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Trả hàng</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
          <v-flex lg9 md9 sm12>
            <v-layout row wrap>
              <template v-if="selectedMenuItem == menus.general">
                <v-flex lg12>
                  <b>Thông tin chung</b>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex lg12>
                  <v-text-field label="Mã sản phẩm" v-model="currentItem.product_code" class="input-group--focused" :rules="requireRules"></v-text-field>
                </v-flex>
                <v-flex lg12>
                  <v-text-field label="Tên sản phẩm" v-model="currentItem.name" class="input-group--focused" :rules="requireRules"></v-text-field>
                </v-flex>
                <v-flex lg12>
                  <h-currency-input label="Đơn giá" v-model="currentItem.price" class="input-group--focused" :decimal="0"></h-currency-input>
                </v-flex>
                <v-flex lg12>
                  <vue-editor v-model="currentItem.description" label="Mô tả sản phẩm" class="input-group--focused" :rules="requireRules"></vue-editor>
                </v-flex>
                <v-flex lg12>
                  <v-autocomplete multiple chips label="Danh mục" :items="categories" v-model="currentItem.categories" item-text="name" item-value="id"></v-autocomplete>
                </v-flex>
                <v-flex lg12>
                  <v-text-field label="Xuất xứ" v-model="currentItem.made_in" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12>
                  <v-text-field label="Link sản phẩm" v-model="currentItem.link" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-layout row wrap pr-6 pl-3>
                  <v-flex lg4>
                    <v-checkbox label="Tự động dừng nhận đơn" v-model="currentItem.auto_deactive"></v-checkbox>
                  </v-flex> 
                  <v-flex lg8>
                    <mh-date-picker plabel="Ngày dừng nhận đơn" v-model="deactiveDate" @onChangeDate="deactiveDate =$event" :disabled="!currentItem.auto_deactive"></mh-date-picker>
                  </v-flex> 
                </v-layout>
                <v-flex lg12>
                  <v-checkbox v-model="currentItem.is_active" label="Kích hoạt sản phẩm" class="input-group--focused"></v-checkbox>
                </v-flex> 
                <!-- <v-flex lg12>
                  <v-checkbox v-model="currentItem.pro_type" label="Sản phẩm sử dụng cho đơn xuất" class="input-group--focused"></v-checkbox>
                </v-flex> -->
                <v-flex lg12>
                  <v-checkbox v-model="currentItem.hidden" label="Sản phẩm ẩn" class="input-group--focused"></v-checkbox>
                </v-flex>
              </template>
              <template v-if="selectedMenuItem == menus.inventory">
                <v-flex lg12>
                  <b>Tồn kho</b>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex lg12>
                  <v-autocomplete label="Quản lý tồn kho" :items="manage_stocks" v-model="currentItem.manage_stock" item-text="name" item-value="value"></v-autocomplete>
                </v-flex>
                <v-flex lg12>
                  <h-currency-input label="Số lượng" v-model="currentItem.qty" class="input-group--focused" :decimal="0" :disabled="!currentItem.manage_stock"></h-currency-input>
                </v-flex>
                <v-flex lg12>
                  <v-autocomplete label="Tồn kho" :items="in_stocks" v-model="currentItem.in_stock" item-text="name" item-value="value"></v-autocomplete>
                </v-flex>
              </template>
              <template v-if="selectedMenuItem == menus.image">
                <v-flex lg12>
                  <b>Hình ảnh</b>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex lg12>
                  <v-btn color="blue-grey" class="ma-2 white--text" @click="dialogFile = true; primaryFile = true" >
                    Ảnh chính
                    <v-icon right dark > mdi-cloud-upload </v-icon>
                  </v-btn>
                </v-flex>
                <v-flex lg12>
                  <div class="image-holder" v-if="currentItem.path">
                    <img :src="'/'+currentItem.path"/>
                    <button type="button" class="btn remove-image" @click="removeFile('base_image', currentItem.entity_file_id)"></button>
                  </div>
                </v-flex>
                <v-flex lg12>
                  <v-btn color="blue-grey" class="ma-2 white--text" @click="dialogFile = true; primaryFile=false" >
                    Ảnh bổ xung
                    <v-icon right dark > mdi-cloud-upload </v-icon>
                  </v-btn>
                </v-flex>
                <v-flex lg12>
                  <v-row>
                    <div class="image-holder" v-for="(img, index) in currentItem.additional_images" :key="index">
                      <img :src="'/'+img.path"/>
                      <button type="button" class="btn remove-image" @click="removeFile('additional_images', index)"></button>
                    </div>
                  </v-row>
                </v-flex>
              </template>
              <template v-if="selectedMenuItem == menus.option">
                <v-flex lg12>
                  <b>Tuỳ chọn thuộc tính</b>
                  <v-divider></v-divider>
                  <v-layout row wrap v-for="(op, index) in currentItem.options" :key="index">
                    <v-flex lg11>
                      <b>{{ op.name }}</b>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex lg1>
                      <v-icon medium @click="deleteOption(index)">delete</v-icon>
                    </v-flex>
                    <v-flex lg6>
                      <v-text-field v-model="op.name" label="Tên thuộc tính" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg6>
                      <v-checkbox v-if="op.position == 0" v-model="op.has_image" label="Hình ảnh" class="input-group--focused"></v-checkbox>
                    </v-flex>
                    <v-layout row wrap pl-8>
                      <v-flex lg12>
                        <b>Nhãn mác</b>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex lg12 row v-for="(val, s_index) in op.option_values" :key="s_index">
                        <v-flex lg2 v-if="op.has_image">
                          <img :src="'/'+val.path" alt="" style="width: 56px; height: 56px; border: 1px solid #ced4da" @click="dialogFile = true; option_value_file = true; option_value_index = val.position;">
                        </v-flex>
                        <v-flex v-bind:class="{'lg11': !op.has_image, 'lg9': op.has_image}">
                          <v-text-field v-model="val.label" label="Tên nhãn mác" class="input-group--focused" @change="addOptionValue(op)"></v-text-field>
                        </v-flex>
                        <v-flex lg1>
                          <v-icon medium @click="deleteOptionValue(op, s_index)">delete</v-icon>
                        </v-flex>
                      </v-flex>
                      <v-flex lg12 justify-end>
                        <v-btn class="mb-2" @click="addOptionValue(op)"> Thêm nhãn mác </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-btn color="blue-grey" class="ma-2 white--text" v-if="!currentItem.options || currentItem.options.length < 2" @click="addOption">
                    Thêm tuỳ chọn mới
                  </v-btn>
                </v-flex>
              </template>
              <template v-if="selectedMenuItem == menus.receipt">
                <v-flex lg12>
                  <v-data-table
                    :headers="detail_headers"
                    :items="receipt_items"
                    :options.sync="pagination"
                    :server-items-length="receipt_total_rows"
                    :footer-props="items_per_page"
                    :must-sort="true"
                    :loading="receipt_loading"
                    :mobile-breakpoint="100"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td><a :href="'/quan-ly-don-hang/don-xuat/'+item.id" target="_blank">{{ item.id }}</a></td>
                        <td>{{ item.customer_first_name }}</td>
                        <td> {{ item.created_at | display_date }}</td>
                        <td> {{ item.created_by }}</td>
                        <td class="text-end">{{ item.qty | currency }}</td>
                      </tr>
                    </template>
                    <template v-slot:body.append v-if="receipt_summary">
                      <tr class="total-summary-td">
                          <td colspan="4" class="text-end font-weight-bold">Tổng số lượng xuất:</td>
                          <td class="text-end font-weight-bold">{{ receipt_summary.total_qty | currency}}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </template>
              <template v-if="selectedMenuItem == menus.return">
                <v-flex lg12>
                  <v-data-table
                    :headers="detail_headers"
                    :items="return_items"
                    :options.sync="pagination"
                    :server-items-length="return_total_rows"
                    :footer-props="items_per_page"
                    :must-sort="true"
                    :loading="return_loading"
                    :mobile-breakpoint="100"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td><a :href="'/quan-ly-don-hang/don-nhap/'+item.id" target="_blank">{{ item.id }}</a></td>
                        <td>{{ item.customer_first_name }}</td>
                        <td> {{ item.created_at | display_date }}</td>
                        <td> {{ item.created_by }}</td>
                        <td class="text-end">{{ item.qty | currency }}</td>
                      </tr>
                    </template>
                    <template v-slot:body.append v-if="return_summary">
                      <tr class="total-summary-td">
                          <td colspan="4" class="text-end font-weight-bold">Tổng số lượng trả hàng:</td>
                          <td class="text-end font-weight-bold">{{ return_summary.total_qty | currency}}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    <upload-file :dialogUpload="dialogFile" title="Quản lý tệp" @closePopup="dialogFile=false" @chooseFile="chooseFile"></upload-file>
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { VueEditor } from "vue2-editor";
import media from "@/components/popups/media";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import { sendSuccessNotice, sendErrorNotice, refreshResource, convertToSlug } from "@/commons/utils";
import _ from "lodash";
import moment from "moment";
import { focus } from 'vue-focus';

export default {
  directives: { focus: focus },
  components: {
      VueEditor,
      "upload-file": media,
      "mh-date-picker": MHDatePicker
  },
  data() {
    return {
      dialogFile: false,
      primaryFile: false,
      option_value_file: false,
      option_value_index: 0,
      subViewName: "product_detail",
      dialogItem: false,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      serviceFilterConditions: [],
      serviceQuickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
      panel: 0,
      menus: {
        general: 0,
        inventory: 1,
        image: 2,
        option: 3,
        receipt: 4,
        return: 5
      },
      selectedMenuItem: 0,
      manage_stocks: [{value: 0, name: 'Không theo dõi hàng tồn kho'}, {value: 1, name: 'Theo dõi hàng tồn kho'}],
      in_stocks: [{value: 0, name: 'Hết hàng'}, {value: 1, name: 'Trong kho'}],
      base_image: null,
      additional_images: null,
      detail_headers: [
        {
          text: "Mã đơn",
          value: "id",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Khách hàng",
          value: "customer_first_name",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Ngày tạo",
          value: "created_at",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Date"],
        },
        {
          text: "Người tạo",
          value: "created_by",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Số lượng",
          value: "qty",
          filterable: true,
          quickSearch: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
      ],
      deactiveDate: null,
      latestOpVal: 0
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.products.loading,
      currentItem: (state) => state.products.selected,
      categories: state => state.categories.all.data,
      receipt_items: state => state.receipts.by_products.data,
      receipt_total_rows: state => state.receipts.by_products.total,
      receipt_summary: state => state.receipts.by_products.summary,
      receipt_loading: (state) => state.receipts.loading,
      return_items: state => state.returns.by_products.data,
      return_total_rows: state => state.returns.by_products.total,
      return_loading: (state) => state.returns.loading,
      return_summary: state => state.returns.by_products.summary,
    }),
    currentId() {
      return Number(this.$route.params.Pid);
    },
    adminRole() {
      return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
    },
    staffRole() {
      return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Staff;
    },
  },
  watch: {
    selectedMenuItem() {
      if (this.selectedMenuItem == this.menus.receipt && this.currentItem.id) {
        this.$store.dispatch("receipts/getListByProduct", {'product_id': this.currentItem.id});
      }
      else if (this.selectedMenuItem == this.menus.return && this.currentItem.id) {
        this.$store.dispatch("returns/getListByProduct", {'product_id': this.currentItem.id});
      }
    },
    currentItem() {
      if(this.currentItem) {
        this.deactiveDate = this.currentItem.deactive_at
        ? moment.parseZone(this.currentItem.deactive_at).toISOString().substr(0, 10)
        : null;
      }
    }
  },
  methods: {
    applyFilterService(filterConditions) {
      this.serviceFilterConditions = filterConditions;
      this.getServiceOfSupplier(this.currentItem.supplier_id);
    },
    quickFilterService(filterConditions) {
      this.serviceQuickFilterConditions = filterConditions;
      this.getServiceOfSupplier(this.currentItem.supplier_id);
    },
    getDetail(is_first_load) {
      this.$store.dispatch("categories/getList");
      if (!this.currentId) {
        this.$store.commit("products/setDetail", {
          id: 0,
          manage_stock: 0,
          in_stock: 1,
          options: [],
          additional_images: []
        });
      } else {
        this.$store
          .dispatch("products/getDetail", this.currentId)
          .then((ret) => {
            ret = ret.data ? ret.data : ret;
            if (_.isEmpty(ret)) {
              sendErrorNotice("Lỗi, không load được dữ liệu.");
            }
          });
      }
    },
    removeFile(zone, index) {
      // this.$store.dispatch("entity_files/removeDetail", entity_file_id);
      if(zone == 'base_image') {
        this.currentItem.entity_file_id = 0;
        this.currentItem.path = '';
      }
      else if(zone == 'additional_images') {
        this.currentItem.additional_images.splice(index, 1);
      }
    },
    saveData() {
      this.$store.dispatch("products/setDetail", {
        data: {...this.currentItem, slug: convertToSlug(`${this.currentItem.product_code}-${this.currentItem.name}-${Math.round(new Date() / 1000)}`), deactive_at: this.deactiveDate ? moment(this.deactiveDate, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null},
        id: this.currentItem.id,
      }).then((p) => {
        if (p.status == 200 && p.data && p.data.id) {
          if(p.data.pro_type == 1) {
            this.$router.push({ name: "ExportProducts" });
          }
          else {
            this.$router.push({ name: "Products" });
          }
        }
      }) ;
    },
    chooseFile(item) {
      if(this.primaryFile) {
        this.currentItem.entity_file_id = 0;
        this.currentItem.file_id = item.id;
        this.currentItem.path = item.path;
      }
      else if (this.option_value_file) {
        const option_value = _.find(this.currentItem.options[0].option_values, {'position': this.option_value_index});
        option_value.path = item.path;
        option_value.file_id = item.id;
        option_value.entity_file_id = 0;
      }
      else {
        this.currentItem.additional_images = this.currentItem.additional_images ? this.currentItem.additional_images : [];
        this.currentItem.additional_images.push({
          entity_file_id: 0,
          file_id: item.id,
          path: item.path
        });
      }
      sendSuccessNotice("Đã thêm ảnh thành công.");
    },
    addOptionValue(op) {
      op.option_values = op.option_values ? op.option_values : [];
      op.option_values.push({'id': 0, 'label': '', 'option_value_translation_id': 0, 'option_id': op.id, 'position': op.option_values.length});
    },
    addOption() {
      this.currentItem.options = this.currentItem.options ? this.currentItem.options : [];
      this.currentItem.options.push({'id': 0, 'name': '', 'option_translation_id': 0, 'position': this.currentItem.options.length, 'has_image': 0, 'option_values': []});
    },
    deleteOptionValue(op, s_index) {
      if(op.option_values) {
        op.option_values.splice(s_index, 1);
      }
    },
    deleteOption(index) {
      if(this.currentItem.options) {
        this.currentItem.options.splice(index, 1);
      }
    }
  },
  mounted() {
    this.getDetail(true);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
  },
};
</script>
